var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcRfid = function SvgIcRfid(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.375,
    viewBox: "0 0 18 16.375",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_-_rfid",
    "data-name": "icon - rfid",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_style_24px",
    d: "M2.359,17.315l1.155.483V10.015L1.42,15.066a1.74,1.74,0,0,0,.939,2.249Zm16.806-3.189L14.891,3.81a1.717,1.717,0,0,0-2.241-.931L6.3,5.508a1.723,1.723,0,0,0-1.06,1.551,1.608,1.608,0,0,0,.129.689L9.642,18.065a1.722,1.722,0,0,0,1.577,1.06A1.783,1.783,0,0,0,11.883,19l6.343-2.629a1.719,1.719,0,0,0,.939-2.241ZM6.97,7.921a.862.862,0,1,1,.862-.862A.864.864,0,0,1,6.97,7.921ZM5.247,17.4A1.729,1.729,0,0,0,6.97,19.125H8.22L5.247,11.937Z",
    transform: "translate(-1.295 -2.75)",
    fill: "#25556e"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcRfid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_rfid.45d31136bb35fbabd575df942fdf235f.svg";